import { styled } from 'style'

const ButtonStyled = styled('button', {
  position: 'relative',

  userSelect: 'none',

  display: 'inline-flex',
  justifyContent: 'center',
  alignItems: 'center',

  transition: '.2s background-color ease',

  borderRadius: '$md',

  fontWeight: '$medium',
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: '$colors$transparent',

  '&:disabled': {
    pointerEvents: 'none',
    filter: 'opacity(0.25)',
  },

  variants: {
    capitalize: {
      true: {
        textTransform: 'capitalize',
      },
    },
    width: {
      default: {
        width: 'auto',
      },
      full: {
        width: '$full',
      },
    },
    size: {
      xs: {
        borderRadius: '$sm',
        padding: '$1 $2',
        fontSize: '$xs',
        lineHeight: '$xs',
      },
      sm: {
        padding: '$1-5 $4',
        fontSize: '$sm',
        lineHeight: '$sm',
      },
      md: {
        padding: '$2-5 $6',
        fontSize: '$sm',
        lineHeight: '$sm',
      },
      lg: {
        padding: '$3-5 $7',
        fontSize: '$md',
        lineHeight: '$md',
      },
    },
    variant: {
      primary: {
        bgc: '$accent',
        color: '$textAccent',

        '&:hover': {
          bgc: '$accentHover',
        },
      },
      secondary: {
        color: '$text2',
        borderColor: '$colors$text4',

        '&:hover': {
          bgc: '$bg2',
        },
      },
      reversed: {
        color: '$textReversed',
        bgc: '$reversed',
      },
      gray: {
        bgc: '$bg3',
        color: '$text1',

        '&:hover': {
          bgc: '$bg2',
        },
      },
      error: {
        bgc: '$error',
        color: '$textAccent',

        '&:hover': {
          bgc: '$errorHover',
        },
      },
      gradient: {
        color: '$textAccent',
        userSelect: 'none',

        backgroundImage: '$gradient !important',

        '&:hover': {
          filter: 'brightness(1.1)',
        },
      },
      marketing: {
        userSelect: 'none',

        bgc: '$marketingGreen',
        border: '1px solid #30A46C',

        '&:hover': {
          filter: 'brightness(1.1)',
        },
      },
    },
    hasText: {
      false: {},
      true: {},
    },
  },

  compoundVariants: [
    {
      hasText: false,
      size: 'xs',
      css: {
        p: '$1',
      },
    },
    {
      hasText: false,
      size: 'sm',
      css: {
        p: '$2',
      },
    },
    {
      hasText: false,
      size: 'md',
      css: {
        p: '$3',
      },
    },
    {
      hasText: false,
      size: 'lg',
      css: {
        p: '$4',
      },
    },
  ],
  defaultVariants: {
    width: 'default',
    variant: 'primary',
    size: 'md',
  },
})

export const ButtonCenterElement = styled('div', {
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  bgc: 'inherit',
  backgroundImage: 'inherit',
  height: '100%',
  width: '100%',
  borderRadius: 'inherit',
})

export const ButtonLoadingLabel = styled('span', {
  position: 'absolute',
  opacity: 0,
})

export const ButtonLeftElement = styled('span', {
  marginInlineEnd: 0,
  variants: {
    hasText: {
      true: {
        marginInlineEnd: '$2',
      },
    },
  },
})

export const ButtonIcon = styled('svg', {
  variants: {
    size: {
      xs: {
        size: 12,
      },
      sm: {
        size: 16,
      },
      md: {
        size: 16,
      },
      lg: {
        size: 18,
      },
    },
  },
  defaultVariants: {
    size: 'md',
  },
})

export default ButtonStyled
